import ROUTER_URL from "@/constant/urls";
import AuthPage from "@/views/Authentication/AuthPage.vue";
import ProfilePage from "@/views/Home/ProfilePage.vue";
import Search from "@/views/Search.vue";
import Notifications from "@/views/Notifications.vue";
import OtherProfilePage from "@/views/Home/OtherProfilePage.vue";
import NetworkPage from "@/views/Home/NetworkPage.vue";
import HomePage from "@/views/Home/HomePage.vue";
import LandingPage from "@/Layouts/Public/LandingPage.vue";
import Disclaimer from "@/Layouts/Public/Disclaimer.vue";
import ShareTrade from "@/views/Home/ShareTrade.vue";
import PrivacyPolicy from "@/Layouts/Public/PrivacyPolicy.vue";
import GroupDetails from "@/views/GroupDetails";
import TrendingPage from "@/views/TrendingPage";
import TrendingMain from "@/views/Trendings/Main.vue";
import TrendingMarket from "@/views/Trendings/Markets.vue";
import TrendingNews from "@/views/Trendings/News.vue";
import TrendingEconomiCalendar from "@/views/Trendings/EconomicCalendar.vue";
import TrendingResearchReport from "@/views/Trendings/ResearchReport.vue";
import Downloads from "@/views/Trendings/downloads.vue";
import PaymentFlow from "@/views/PaymentFlow/payment.vue";
import PremiumGroupsList from "@/views/GroupList.vue";
import PremiumGroupDetails from "@/views/PremiumGroupDetails.vue";
import TrendingWebinarsList from "@/views/Trendings/Webinars/Webinars-list.vue";
import ViewAllGroupHorizontal from "@/views/ViewAllGroupHorizontal";
// import { isAuthenticated } from "@/common/commonFunctions";

import VideoCourse from "@/components/Trending/VideoCourse/VideoCourseList";
import TransactionsDetail from "@/views/TransactionsDetail/TransactionDetail.vue";
import MyMembership from "@/views/MyMembership/MyMembership";
import Gamification from "@/views/Trendings/gamification.vue";
import PremiumTrade from "@/views/Trendings/unlockPremiumTrade.vue";

// import ContainerForPlaylistAndProfileCard from "../components/Profile/VideoCourse/VideoPlayList/ContainerForPlaylistAndProfileCard.vue";
// import PlaylistVideosListing from "../components/Profile/VideoCourse/VideoPlayList/DetailedPlaylist/PlaylistVideosListing.vue";
const routes = [
  {
    path: ROUTER_URL.landingPage.link,
    name: ROUTER_URL.landingPage.name,
    component: LandingPage,
    meta: {
      guest: true,
    },
  },
  {
    path: "/disclaimer",
    name: "Disclaimer",
    component: Disclaimer,
    meta: {
      guest: true,
    },
  },
  {
    path: "/subscribe",
    name: "Subscribe",
    component: PaymentFlow,
    meta: {
      guest: true,
      layout: "auth",
      title: "Subcribe",
    },
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: {
      guest: true,
    },
  },

  // Auth routes
  {
    name: ROUTER_URL.auth.name,
    path: ROUTER_URL.auth.link,
    component: AuthPage,
    meta: {
      name: ROUTER_URL.auth.name,
      title: ROUTER_URL.auth.title,
      guest: true,
    },
    children: [
      // {
      //   path: "/subscribe",
      //   name: "Subscribe",
      //   component: PaymentFlow,
      //   meta: {
      //     guest: true,
      //     layout: "auth",
      //     title: "Subcribe",
      //   },
      // },
      {
        name: ROUTER_URL.auth.children.login.name,
        path: ROUTER_URL.auth.children.login.link,
        component: () => import("@/components/Authentication/login.vue"),
        meta: {
          guest: true,
          name: ROUTER_URL.auth.children.login.name,
          title: ROUTER_URL.auth.children.login.title,
          layout: "auth",
        },
      },
      {
        name: ROUTER_URL.auth.children.verifyOtp.name,
        path: ROUTER_URL.auth.children.verifyOtp.link,
        component: () => import("../components/Authentication/VerifyOtp.vue"),
        meta: {
          guest: true,
          name: ROUTER_URL.auth.children.verifyOtp.name,
          title: ROUTER_URL.auth.children.verifyOtp.title,
          layout: "auth",
        },
      },
      {
        name: ROUTER_URL.auth.children.completeProfile.name,
        path: ROUTER_URL.auth.children.completeProfile.link,
        component: () => import("../components/Authentication/Profile.vue"),
        meta: {
          guest: true,
          name: ROUTER_URL.auth.children.completeProfile.name,
          title: ROUTER_URL.auth.children.completeProfile.title,
          layout: "auth",
        },
      },
    ],
  },
  // Admin Panel Routes
  {
    name: ROUTER_URL.adminPanel.name,
    path: ROUTER_URL.adminPanel.link,
    component: () => import("../Layouts/AdminLayout/AdminLayout.vue"),
    meta: {
      name: ROUTER_URL.adminPanel.name,
      title: ROUTER_URL.adminPanel.title,
      guest: false,
    },
    children: [
      {
        name: ROUTER_URL.adminPanel.children.group.name,
        path: ROUTER_URL.adminPanel.children.group.link,
        component: () => import("@/views/AdminPanel/Groups/Groups.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.adminPanel.children.group.name,
          title: ROUTER_URL.adminPanel.children.group.title,
          layout: "AdminPanel",
        },
      },
      {
        name: ROUTER_URL.adminPanel.children.videoCourses.name,
        path: ROUTER_URL.adminPanel.children.videoCourses.link,
        component: () =>
          import("@/views/AdminPanel/VideoCourses/VideoCourses.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.adminPanel.children.videoCourses.name,
          title: ROUTER_URL.adminPanel.children.videoCourses.title,
          layout: "AdminPanel",
        },
      },
      {
        name: ROUTER_URL.adminPanel.children.teams.name,
        path: ROUTER_URL.adminPanel.children.teams.link,
        component: () => import("@/views/AdminPanel/Teams/Teams.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.adminPanel.children.teams.name,
          title: ROUTER_URL.adminPanel.children.teams.title,
          layout: "AdminPanel",
        },
      },
      {
        name: ROUTER_URL.adminPanel.children.playlistDetail.name,
        path: ROUTER_URL.adminPanel.children.playlistDetail.link,
        component: () =>
          import(
            "../components/VideoCourse/PlaylistDetailPage/PlaylistDetailPage.vue"
          ),
        meta: {
          guest: true,
          name: ROUTER_URL.adminPanel.children.playlistDetail.name,
          title: ROUTER_URL.adminPanel.children.playlistDetail.title,
          layout: "AdminPanel",
        },
      },
      {
        name: ROUTER_URL.adminPanel.children.videoDetail.name,
        path: ROUTER_URL.adminPanel.children.videoDetail.link,
        component: () =>
          import(
            "../components/VideoCourse/VideoDetailPage/VideoDetailPage.vue"
          ),
        meta: {
          guest: true,
          name: ROUTER_URL.adminPanel.children.videoDetail.name,
          title: ROUTER_URL.adminPanel.children.videoDetail.title,
          layout: "AdminPanel",
        },
      },
    ],
  },

  // Public user layout
  {
    name: ROUTER_URL.userPanel.name,
    path: ROUTER_URL.userPanel.link,
    component: () => import("../Layouts/PublicUser/PublicUser.vue"),
    meta: {
      name: ROUTER_URL.userPanel.name,
      title: ROUTER_URL.userPanel.title,
      guest: false,
    },
    children: [
      {
        name: ROUTER_URL.userPanel.children.home.name,
        path: ROUTER_URL.userPanel.children.home.link,
        component: HomePage,
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.home.name,
          title: ROUTER_URL.userPanel.children.home.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.trending.name,
        path: ROUTER_URL.userPanel.children.trending.link,
        component: TrendingPage,
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.trending.name,
          title: ROUTER_URL.userPanel.children.trending.title,
          layout: "userPanel",
        },
        children: [
          {
            name: ROUTER_URL.userPanel.children.trending.children.main.children
              .premiumGroups.name,
            path: ROUTER_URL.userPanel.children.trending.children.main.children
              .premiumGroups.link,
            component: PremiumGroupsList,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.main
                .children.premiumGroups.name,
              title:
                ROUTER_URL.userPanel.children.trending.children.main.children
                  .premiumGroups.title,
              layout: "userPanel",
            },
          },

          {
            name: ROUTER_URL.userPanel.children.trending.children.main.children
              .allGroups.name,
            path: ROUTER_URL.userPanel.children.trending.children.main.children
              .allGroups.link,
            component: ViewAllGroupHorizontal,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.main
                .children.allGroups.name,
              title:
                ROUTER_URL.userPanel.children.trending.children.main.children
                  .allGroups.title,
              layout: "userPanel",
            },
          },

          // {
          //   name: ROUTER_URL.userPanel.children.premiumGroup.name,
          //   path: ROUTER_URL.userPanel.children.premiumGroup.link,
          //   component: PremiumGroupDetails,
          //   meta: {
          //     guest: false,
          //     name: ROUTER_URL.userPanel.children.premiumGroup.name,
          //     title:
          //       ROUTER_URL.userPanel.children.premiumGroup.title,
          //     layout: "userPanel",
          //   },
          // },

          {
            name: ROUTER_URL.userPanel.children.trending.children.main.name,
            path: ROUTER_URL.userPanel.children.trending.children.main.link,
            component: TrendingMain,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.main.name,
              title: ROUTER_URL.userPanel.children.trending.children.main.title,
              layout: "userPanel",
            },
          },
          {
            name: ROUTER_URL.userPanel.children.trending.children.markets.name,
            path: ROUTER_URL.userPanel.children.trending.children.markets.link,
            component: TrendingMarket,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.markets
                .name,
              title:
                ROUTER_URL.userPanel.children.trending.children.markets.title,
              layout: "userPanel",
            },
          },
          {
            name: ROUTER_URL.userPanel.children.trending.children.news.name,
            path: ROUTER_URL.userPanel.children.trending.children.news.link,
            component: TrendingNews,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.news.name,
              title: ROUTER_URL.userPanel.children.trending.children.news.title,
              layout: "userPanel",
            },
          },
          {
            name: ROUTER_URL.userPanel.children.trending.children.economic.name,
            path: ROUTER_URL.userPanel.children.trending.children.economic.link,
            component: TrendingEconomiCalendar,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.economic
                .name,
              title:
                ROUTER_URL.userPanel.children.trending.children.economic.title,
              layout: "userPanel",
            },
          },
          {
            name: ROUTER_URL.userPanel.children.trending.children.report.name,
            path: ROUTER_URL.userPanel.children.trending.children.report.link,
            component: TrendingResearchReport,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.report.name,
              title:
                ROUTER_URL.userPanel.children.trending.children.report.title,
              layout: "userPanel",
            },
          },
          {
            name: ROUTER_URL.userPanel.children.trending.children.downloads
              .name,
            path: ROUTER_URL.userPanel.children.trending.children.downloads
              .link,
            component: Downloads,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.downloads
                .name,
              title:
                ROUTER_URL.userPanel.children.trending.children.downloads.title,
              layout: "userPanel",
            },
          },
          {
            name: ROUTER_URL.userPanel.children.trending.children.gamification
              .name,
            path: ROUTER_URL.userPanel.children.trending.children.gamification
              .link,
            component: Gamification,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.gamification
                .name,
              title:
                ROUTER_URL.userPanel.children.trending.children.gamification
                  .title,
              layout: "userPanel",
            },
          },
          {
            name: ROUTER_URL.userPanel.children.trending.children.premiumTrade
              .name,
            path: ROUTER_URL.userPanel.children.trending.children.premiumTrade
              .link,
            component: PremiumTrade,
            meta: {
              guest: false,
              name: ROUTER_URL.userPanel.children.trending.children.premiumTrade
                .name,
              title:
                ROUTER_URL.userPanel.children.trending.children.premiumTrade
                  .title,
              layout: "userPanel",
            },
          },
          // {
          //   name: ROUTER_URL.userPanel.children.trending.children.main.children.webinars.name,
          //   path: ROUTER_URL.userPanel.children.trending.children.main.children.webinars.link,
          //   component: TrendingWebinarsList,
          //   meta: {
          //     guest: false,
          //     name: ROUTER_URL.userPanel.children.trending.children.main.children.webinars
          //       .name,
          //     title:
          //       ROUTER_URL.userPanel.children.trending.children.main.children.webinars.title,
          //     layout: "userPanel",
          //   },
          // },
        ],
      },
      {
        name: ROUTER_URL.userPanel.children.premiumGroup.name,
        path: ROUTER_URL.userPanel.children.premiumGroup.link,
        component: PremiumGroupDetails,
        meta: {
          guest: true,
          name: ROUTER_URL.userPanel.children.premiumGroup.name,
          title: ROUTER_URL.userPanel.children.premiumGroup.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.webinars.name,
        path: ROUTER_URL.userPanel.children.webinars.link,
        component: TrendingWebinarsList,
        meta: {
          guest: true,
          name: ROUTER_URL.userPanel.children.webinars.name,
          title: ROUTER_URL.userPanel.children.webinars.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.videoCourseList.name,
        path: ROUTER_URL.userPanel.children.videoCourseList.link,
        component: VideoCourse,
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.videoCourseList.name,
          title: ROUTER_URL.userPanel.children.videoCourseList.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.myProfile.name,
        path: ROUTER_URL.userPanel.children.myProfile.link,
        component: ProfilePage,
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.myProfile.name,
          title: ROUTER_URL.userPanel.children.myProfile.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.question.name,
        path: ROUTER_URL.userPanel.children.question.link,
        component: () => import("@/components/Questioners/questionPage.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.question.name,
          title: ROUTER_URL.userPanel.children.question.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.downloadTrade.name,
        path: ROUTER_URL.userPanel.children.downloadTrade.link,
        component: () => import("@/components/Profile/downloadTrade.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.downloadTrade.name,
          title: ROUTER_URL.userPanel.children.downloadTrade.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.downloadTradeReportList.name,
        path: ROUTER_URL.userPanel.children.downloadTradeReportList.link,
        component: () =>
          import("@/components/Profile/downloadTradeReportList.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.downloadTradeReportList.name,
          title: ROUTER_URL.userPanel.children.downloadTradeReportList.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.copyExperTarde.name,
        path: ROUTER_URL.userPanel.children.copyExperTarde.link,
        component: () =>
          import("@/components/gamification/copyExpertTrade.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.copyExperTarde.name,
          title: ROUTER_URL.userPanel.children.copyExperTarde.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.followSebiUser.name,
        path: ROUTER_URL.userPanel.children.followSebiUser.link,
        component: () => import("@/components/gamification/followSebiUser.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.followSebiUser.name,
          title: ROUTER_URL.userPanel.children.followSebiUser.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.otherProfile.name,
        path: ROUTER_URL.userPanel.children.otherProfile.link,
        component: OtherProfilePage,
        meta: {
          guest: true,
          name: ROUTER_URL.userPanel.children.otherProfile.name,
          link: ROUTER_URL.userPanel.children.otherProfile.link,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.network.name,
        path: ROUTER_URL.userPanel.children.network.link,
        component: NetworkPage,
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.network.name,
          link: ROUTER_URL.userPanel.children.network.link,
          layout: "userPanel",
        },
      },
      {
        path: "/trade/:id/:name",
        name: "ShareTrade",
        component: ShareTrade,
        meta: {
          guest: true,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.newsDetail.name,
        path: ROUTER_URL.userPanel.children.newsDetail.link,
        component: () =>
          import(
            "@/components/SecurityPage/TabSection/NewsSection/NewsDetailPage/NewsDetailPage.vue"
          ),
        meta: {
          guest: true,
          name: ROUTER_URL.userPanel.children.newsDetail.name,
          title: ROUTER_URL.userPanel.children.newsDetail.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.search.name,
        path: ROUTER_URL.userPanel.children.search.link,
        component: Search,
        meta: {
          guest: true,
          name: ROUTER_URL.userPanel.children.search.name,
          title: ROUTER_URL.userPanel.children.search.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.searchPage.name,
        path: ROUTER_URL.userPanel.children.searchPage.link,
        component: () => import("../views/SearchPage/SearchPage.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.searchPage.name,
          title: ROUTER_URL.userPanel.children.searchPage.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.recentSearch.name,
        path: ROUTER_URL.userPanel.children.recentSearch.link,
        component: () =>
          import("../views/SearchPage/RecentSearch/RecentSearch.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.recentSearch.name,
          title: ROUTER_URL.userPanel.children.recentSearch.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.watchlistPage.name,
        path: ROUTER_URL.userPanel.children.watchlistPage.link,
        component: () => import("../views/WatchlistPage/WatchlistPage.vue"),
        meta: {
          guest: true,
          name: ROUTER_URL.userPanel.children.watchlistPage.name,
          title: ROUTER_URL.userPanel.children.watchlistPage.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.notification.name,
        path: ROUTER_URL.userPanel.children.notification.link,
        component: Notifications,
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.notification.name,
          title: ROUTER_URL.userPanel.children.notification.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.groups.name,
        path: ROUTER_URL.userPanel.children.groups.link,
        component: GroupDetails,
        meta: {
          guest: true,
          name: ROUTER_URL.userPanel.children.groups.name,
          link: ROUTER_URL.userPanel.children.groups.link,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.transactions.name,
        path: ROUTER_URL.userPanel.children.transactions.link,
        component: TransactionsDetail,
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.transactions.name,
          title: ROUTER_URL.userPanel.children.transactions.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.membership.name,
        path: ROUTER_URL.userPanel.children.membership.link,
        component: MyMembership,
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.membership.name,
          title: ROUTER_URL.userPanel.children.membership.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.videoAndPlaylist.name,
        path: ROUTER_URL.userPanel.children.videoAndPlaylist.link,
        component: () =>
          import(
            "../components/VideoCourse/VideoAndPlaylistPage/VideoAndPlaylistPage.vue"
          ),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.videoAndPlaylist.name,
          title: ROUTER_URL.userPanel.children.videoAndPlaylist.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.playlistDetail.name,
        path: ROUTER_URL.userPanel.children.playlistDetail.link,
        component: () =>
          import(
            "../components/VideoCourse/PlaylistDetailPage/PlaylistDetailPage.vue"
          ),
        meta: {
          guest: true,
          name: ROUTER_URL.userPanel.children.playlistDetail.name,
          title: ROUTER_URL.userPanel.children.playlistDetail.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.videoDetail.name,
        path: ROUTER_URL.userPanel.children.videoDetail.link,
        component: () =>
          import(
            "../components/VideoCourse/VideoDetailPage/VideoDetailPage.vue"
          ),
        meta: {
          guest: true,
          name: ROUTER_URL.userPanel.children.videoDetail.name,
          title: ROUTER_URL.userPanel.children.videoDetail.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.tradingSection.name,
        path: ROUTER_URL.userPanel.children.tradingSection.link,
        component: () => import("../views/TradingSection/TradingSection.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.tradingSection.name,
          title: ROUTER_URL.userPanel.children.tradingSection.title,
          layout: "userPanel",
        },
      },
      {
        name: ROUTER_URL.userPanel.children.portfolioEvaluation.name,
        path: ROUTER_URL.userPanel.children.portfolioEvaluation.link,
        component: () =>
          import("../views/TradingSection/portfolioEvaluation.vue"),
        meta: {
          guest: false,
          name: ROUTER_URL.userPanel.children.portfolioEvaluation.name,
          title: ROUTER_URL.userPanel.children.portfolioEvaluation.title,
          layout: "userPanel",
        },
      },
      // {
      //   path: "/videos-listing",
      //   name: "videosListing",
      //   component: ContainerForPlaylistAndProfileCard,
      //   meta: {
      //     guest: false,
      //     layout: "userPanel",
      //   },
      // },
      // {
      //   path: "/Playlist-Videos",
      //   name: "Playlist_Videos",
      //   component: PlaylistVideosListing,
      //   meta: {
      //     guest: false,
      //     layout: "userPanel",
      //   },
      // },
    ],
  },
];
// routes.beforeEach((to, from, next) => {

//   if (!isAuthenticated()) {
//     next({ name: 'login' }); // Redirect to login
//   } else {
//     next(); // Proceed with navigation
//   }
// });
export default routes;
